/**
 * Shared token helpers and types for the auth modules.
 */

export const REFRESH_TOKEN_KEY = 'zecure_cognito_refresh_token';
export const ACCESS_TOKEN_KEY = 'zecure_cognito_access_token';
export const ID_TOKEN_KEY = 'zecure_cognito_id_token';

export interface CognitoTokens {
  accessToken: string;
  idToken: string;
  refreshToken: string;
}

export interface CognitoAuthResult {
  tokens: CognitoTokens;
  challengeName?: string;
  session?: string;
  userAttributes?: Record<string, string>;
}

export function isCognitoConfigured(): boolean {
  const poolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
  const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
  return Boolean(poolId && clientId);
}

export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    return payload;
  } catch {
    return null;
  }
}
